import { match } from 'ts-pattern'

import type {
  ServiceGetByIdResponse,
  ServiceQueryOptionType
} from '@/types/service'

import { api, handleAxiosError } from '@/lib/axios'

import type { RecapFarmerInstitutionQueryResult } from './dto'
import type {
  RecapFarmerInstitution,
  RecapFarmerInstitutionMeta
} from './types'

import { toRecords } from './dto'

const RECAP_FARMER_INSTITUTION_QUERY_KEY = (
  key?: string | Record<string, any>
) => ['recap_farmer_institution', key] as const

interface GetRecapParams {
  region: 'national' | 'province' | 'city' | 'district'
  province_code?: string
  city_code?: string
  district_code?: string
}

type FarmerInstitutionApiResponse =
  ServiceGetByIdResponse<RecapFarmerInstitution> & {
    meta?: RecapFarmerInstitutionMeta
  }

const getRecap = (
  params: GetRecapParams
): ServiceQueryOptionType<RecapFarmerInstitutionQueryResult> => ({
  queryKey: RECAP_FARMER_INSTITUTION_QUERY_KEY(params),
  queryFn: async () => {
    try {
      const path = match(params.region)
        .with('province', () => `/province/${params.province_code}`)
        .with(
          'city',
          () => `/province/${params.province_code}/city/${params.city_code}`
        )
        .with(
          'district',
          () =>
            `/province/${params.province_code}/city/${params.city_code}/district/${params.district_code}`
        )
        .otherwise(() => '')

      const res = await api.get<FarmerInstitutionApiResponse>(
        `/report/extension-personnel-main/recap-extension-farmer${path}`
      )

      return toRecords(res.data)
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

export const farmerInstitution = {
  queryKey: RECAP_FARMER_INSTITUTION_QUERY_KEY,
  getRecap
}
